import { useRepairsLink } from "duck/ui/chat/components/messages/PriceAdvisorMessage/utils";
import { useTranslation } from "react-i18next";

import { APIFilter } from "shared/api/utils";
import { useConfigContext } from "shared/contexts/ConfigContext";

import { REPAIRS_PAGE_CONFIG_KEY } from "pages/SuperAdmin/PagesConfig/types";

import Tooltip from "features/components/Tooltip";
import { DEFAULT_FILTER_BUILDER_STATE } from "features/ui/Filters/FilterBuilder/constants";
import {
  filterBuilderQueryToFilterBuilderState,
  getFiltersQuery,
} from "features/ui/Filters/FilterBuilder/utils";
import Link from "features/ui/Link";

interface Props {
  assetFilter: string;
  repairFilter?: APIFilter[];
  repairCount?: number;
}

const PriceAdvisorRepairsLink = ({
  assetFilter,
  repairFilter = [],
  repairCount = 0,
}: Props) => {
  const { t } = useTranslation("duck");
  const { pages } = useConfigContext();

  const assetFilterState = filterBuilderQueryToFilterBuilderState(assetFilter);

  const link = useRepairsLink(
    getFiltersQuery(undefined, repairFilter),
    getFiltersQuery(assetFilterState ?? DEFAULT_FILTER_BUILDER_STATE)
  );

  if (!pages[REPAIRS_PAGE_CONFIG_KEY]) {
    return (
      <span className="text-xs">
        {t("recent_repairs", { count: repairCount })}
      </span>
    );
  }

  return (
    <Link to={link} target="_blank">
      <Tooltip title={t("repairs_tooltip")}>
        <span className="text-xs">
          {t("recent_repairs", { count: repairCount })}
        </span>
      </Tooltip>
    </Link>
  );
};

export default PriceAdvisorRepairsLink;
